import { defineStore } from 'pinia'
import {
  getAddressesV2,
  addDeliveryAddress,
  deleteDeliveryAddress,
  editDeliveryAddress
} from '@/api/addressBookApi'
import { useRootStore } from '@/stores/store'

export const useAddressBookStore = defineStore('addressBook', {
  state: () => ({
    addresses: [],
    invoiceAddresses: [],
    deliveryAddresses: []
  }),
  actions: {
    async hydrate() {
      const kvdm = useRootStore().theme.customFields.kvdmPortal === true
      const addresses = await getAddressesV2(kvdm)
      this.invoiceAddresses = addresses.invoiceAddresses
      this.deliveryAddresses = addresses.deliveryAddresses
    },
    async addDeliveryAddress(address) {
      try {
        const kvdm = useRootStore().theme.customFields.kvdmPortal === true
        const response = await addDeliveryAddress(address)
        const addresses = await getAddressesV2(kvdm)
        this.deliveryAddresses = addresses.deliveryAddresses
        return response
      } catch (error) {
        console.log('error saving address')
      }
    },
    async deleteDeliveryAddress(id) {
      const kvdm = useRootStore().theme.customFields.kvdmPortal === true
      await deleteDeliveryAddress(id)
      const addresses = await getAddressesV2(kvdm)
      this.deliveryAddresses = addresses.deliveryAddresses
    },
    async editDeliveryAddress(address) {
      const kvdm = useRootStore().theme.customFields.kvdmPortal === true
      const response = await editDeliveryAddress(address)
      const addresses = await getAddressesV2(kvdm)
      this.deliveryAddresses = addresses.deliveryAddresses
      return response
    },
    saveNewInvoiceAddress(address) {
      let index = -1
      if (address.newCustomer) {
        index = this.invoiceAddresses.findIndex(
          (addr) => addr.newCustomer === true
        )
      }

      if (index === -1) {
        index = this.invoiceAddresses.findIndex(
          (addr) => addr.customerNumber == address.customerNumber
        )
      }

      if (index > -1) {
        this.invoiceAddresses.splice(index, 1, address)
      } else {
        this.invoiceAddresses.push(address)
      }
    },
    setInvAddressDefault(customer) {
      this.invoiceAddresses.forEach((a) => (a.default = false))
      const addr = this.invoiceAddresses.find(
        (a) => a.customerNumber === customer
      )
      if (addr) {
        addr.default = true
      }
    },
    addAddressProject(project) {
      const address = this.invoiceAddresses.find(
        (addr) => addr.customerNumber == project.customerNumber
      )
      if (address) {
        if (!address.projects) address.projects = []
        address.projects.push(project)
      }
    },
    deleteAddressProject(project) {
      const address = this.invoiceAddresses.find(
        (addr) => addr.customerNumber == project.customerNumber
      )
      if (address) {
        const index = address.projects.findIndex(
          (proj) => proj.id === project.id
        )
        if (index !== -1) address.projects.splice(index, 1)
      }
    },
    addAddressReference(reference) {
      const address = this.invoiceAddresses.find(
        (addr) => addr.customerNumber == reference.customerNumber
      )
      if (address) {
        if (!address.references) address.references = []
        address.references.push(reference)
      }
    },
    deleteAddressReference(reference) {
      const address = this.invoiceAddresses.find(
        (addr) => addr.customerNumber == reference.customerNumber
      )
      if (address) {
        const index = address.references.findIndex(
          (ref) => ref.id === reference.id
        )
        if (index !== -1) address.references.splice(index, 1)
      }
    },
    deleteInvoiceAddress(id) {
      const index = this.invoiceAddresses.findIndex(
        (addr) => addr.customerNumber === id
      )
      if (index !== -1) this.invoiceAddresses.splice(index, 1)
    }
  }
})
